import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setAmount, setSku } from './productSlice';

import { roundNumber } from '../../lib/utils';

export default function AmountSelect() {
  const { availableAmounts: allAvailableAmounts, amount } = useSelector((state) => state.product);
  const { selected: selectedTransferType } = useSelector((state) => state.transferTypes);
  const { selected: selectedNetwork } = useSelector((state) => state.networks);

  const currencies = useSelector((state) => state.currencies);

  const dispatch = useDispatch();

  const availableAmounts = allAvailableAmounts[selectedNetwork.name][selectedTransferType];

  const firstAvailableAmount = allAvailableAmounts[selectedNetwork.name][selectedTransferType][0];
  const currentAmountIsAvailable = availableAmounts.includes(amount);

  useEffect(() => {
    if (!amount) {
      dispatch(setAmount(firstAvailableAmount));

      if (selectedTransferType === 1) {
        dispatch(setSku(findSkuFromAmount(firstAvailableAmount, selectedNetwork)));
      }
    }
  }, [dispatch, amount, selectedNetwork, selectedTransferType, firstAvailableAmount]);

  useEffect(() => {
    if (!currentAmountIsAvailable) {
      dispatch(setAmount(firstAvailableAmount));

      if (selectedTransferType === 1) {
        dispatch(setSku(findSkuFromAmount(firstAvailableAmount, selectedNetwork)));
      }
    }
  }, [
    dispatch,
    currentAmountIsAvailable,
    firstAvailableAmount,
    selectedNetwork,
    selectedTransferType,
  ]);

  const handleAmountChange = (direction) => {
    const currentAmountIndex = availableAmounts.indexOf(amount);

    if (availableAmounts[currentAmountIndex + direction]) {
      dispatch(setAmount(availableAmounts[currentAmountIndex + direction]));

      if (selectedTransferType === 1) {
        dispatch(
          setSku(
            findSkuFromAmount(availableAmounts[currentAmountIndex + direction], selectedNetwork)
          )
        );
      }
    }
  };

  if (!amount) {
    return (
      <div className="amount-picker-wrapper center">No data available for selected network</div>
    );
  }

  const recipientAmountString = `${roundNumber(currencies.receiver.rate * amount, 2)} ${
    currencies.receiver.name
  }`;

  const senderAmountString = `${roundNumber(currencies.sender.rate * amount, 2)} ${
    currencies.sender.name
  }`;

  return (
    <div className="amount-picker-wrapper">
      <div className="amount-picker">
        <div className="minus" onClick={() => handleAmountChange(-1)}></div>
        <div className="amount-wrapper">
          <div className="amount">{senderAmountString}</div>
          {currencies.receiver.rate && (
            <div className="amount-converted">{recipientAmountString}</div>
          )}
        </div>
        <div className="plus" onClick={() => handleAmountChange(1)}></div>
      </div>
    </div>
  );
}

function findSkuFromAmount(amount, selectedNetwork, selectedTransferType = 1) {
  //top up
  if (selectedTransferType === 1 && typeof amount === 'number' && amount > 0) {
    const selectedPacket = selectedNetwork.topUpPackets.find((packet) => packet.amount === amount);
    return selectedPacket.sku;
  }
}
